import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import "./Scan.css";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";
import { formatDate } from "../../utils/Utilities.js";

const OutScan = () => {
  const handleRedirect = () => {
    navigate("/inscan");
  }
  const handleRedirect2 = () => {
    navigate("/listOutScanByDate");
  }

  // State to store form data and API response message
  const { auth } = useAuth();
  const [awbNumber, setAwbNumber] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const OUT_SCAN_URL = "/api/out-scan"; // Replace with the correct API endpoint to fetch users
  const [loading, setLoading] = useState(false); // Set loading initially to false
  const [error, setError] = useState(null); // To handle errors
  const LIST_OUT_SCAN_URL = "api/list-outscan"; // Replace with the correct API endpoint to fetch ListOutScanByDate
  const [todayOutScan, setTodayOutScan] = useState([]);




  const fetchListOutScan = async (fromDate, toDate) => {
    setLoading(true); // Start loading spinner
    try {
      const today = new Date();

      const fromDate_Formated = formatDate(today);
      const toDate_Formated = formatDate(today);

      const data = {
        franchise_id: auth.franchise_id,
        from_date: fromDate_Formated,
        to_date: toDate_Formated,
      };

      const response = await axiosPrivate.get(LIST_OUT_SCAN_URL, {
        params: data,
      });

      setTodayOutScan(response.data); // Store the list of todayOutScan into the state
      setLoading(false); // Stop loading spinner
      setError(null); // Clear any previous error
    } catch (error) {
      console.error("Error fetching Bookings Consignments:", error);
      setError("Failed to load Booking Consignments");
      setLoading(false); // Set loading to false even if there is an error
    }
  };



  useEffect(() => {
    fetchListOutScan();
  }, []);




  const postOutScan = async () => {
    try {
      const data = {
        awb_number: awbNumber,
        franchise_id: auth.franchise_id,
      };
      const response = await axiosPrivate.post(OUT_SCAN_URL, data);
      console.log(response.data);
      setResponseMessage(response.data); // Store the list of users into the state
    } catch (error) {
      if (error.response) {
        // If there is an error response from the server
        console.error("Error:", error.response.data.message);
        setResponseMessage(error.response.data.message); // Set the error message to the state
      } else {
        // If there is no error response (network error, etc.)
        console.error("Error:", error.message);
        setResponseMessage("An unexpected error occurred."); // Set a generic error message
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent page reload on form submit
    await postOutScan();
    await fetchListOutScan();

  };
  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate('/login');
  }


  return (
    <>

      {/* <div className="dashhead">
                <Row>
                    <Col><h5 className="dashhe">OutScan</h5></Col>
                    <Col>
                    <div className="dashdiv">
                    <strong><i className="bx bxs-user icon dashicon"></i></strong> {auth?.name} / 
                    
                    <Link onClick={signOut} className="dashsign"><strong> <i className="bx bx-log-out icon dashiconr"></i></strong>  Sign Out</Link> 
                    </div>
                    </Col>
                </Row>
            </div> */}


      <section className="inscanbody">
        {/* <h1 className="scanhead">outscan Page</h1> */}

        <div className="wrapper4">
          <div className="d-flex align-items-center">
            {/* Left */}
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary newviewbtn"
            >
              ← Back
            </button>

            {/* Right */}
            <div className="d-flex gap-2 ms-auto">
              <button
                onClick={handleRedirect2}
                type="button"
                className="btn btn-success top-bt"
              >
                OutScan List
              </button>

              <button
                onClick={handleRedirect}
                type="button"
                className="btn btn-success top-bt"
              >
                In Scan
              </button>
            </div>
          </div>

          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">In Scan</button> */}
          <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

            <h3>Out Scan</h3>
            <Row>
              <Col></Col>
              <Col>
                <center><div className="input-boxs">
                  <label htmlFor="awb_number">AWB Number  </label>
                  <input
                    type="text"
                    id="awb_number"
                    placeholder=""
                    value={awbNumber}
                    onChange={(e) => setAwbNumber(e.target.value)}
                    required
                  />
                  {/* <i className="bx bxs-user"></i> */}
                </div></center>


                <center><button type="submit" className="btn scanbutton">Submit</button></center>
              </Col>
              <Col></Col>
            </Row>


          </form>
          {/* Display response message */}
          {responseMessage && (
            <div className="response-message">
              <p>{responseMessage.message || responseMessage}</p>
            </div>
          )}

          <div>
            {loading && <p>Loading...</p>}
            {error && <p>{error}</p>}

            {!loading && !error && todayOutScan.length > 0 && (
              <table>
                <thead>
                  <tr>
                    <th>AWB Number</th>
                    <th>Consignment Type</th>
                    <th>Goods Name</th>
                    <th>Quantity</th>
                    <th>Weight</th>
                    <th>Inscan Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {todayOutScan.map((booking, index) => (
                    <tr key={index}>
                      <td>{booking.awb_number}</td>
                      <td>{booking.consignment_type}</td>
                      <td>{booking.goods_name}</td>
                      <td>{booking.quantity}</td>
                      <td>{booking.weight}</td>
                      <td>{booking.scan_time}</td>
                      <td>{booking.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {!loading && !error && todayOutScan.length === 0 && (
              <p>No bookings found</p>
            )}
          </div>
        </div>
      </section>

      <TopBar />
    </>
  )
}

export default OutScan